import {createContext, use} from 'react'

import type {SessionComposerModel} from './use-session-composer'

export const ComposerContext = createContext<SessionComposerModel | null>(null)

export function useComposer() {
  const composer = use(ComposerContext)

  if (!composer) throw new Error('useComposer must be used inside SessionComposer')

  return composer
}
